if (!customElements.get("countdown-timer-bar")) {
  class CountdownBar extends HTMLElement {
    constructor() {
      super();
      this.calcHeight();
    }

    calcHeight() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          document.documentElement.style.setProperty(
            "--countdown-bar-height",
            entry.isIntersecting ? `${entry.boundingClientRect.height}px` : "0px"
          );
        });
      });

      observer.observe(this);
    }
  }

  customElements.define("countdown-timer-bar", CountdownBar);
}